export default {
  apiUrl: 'https://png-api.cenango.com/api/v1/'
};
